// Register Svelte components for use with Rails svelte_component helper. Used
// in frontend/entrypoints/CONTROLLER_NAME.js entrypoints to enhance .erb views.

import { registerComponent as register, getComponent, listComponents } from "./registerComponent";
import onElementExists from "./onElementExists";
import InjectHtml from "./InjectHtml.svelte";

onElementExists("[data-svelte-component]", function (target) {
  const key = target.dataset.svelteComponent;
  const componentClass = getComponent(key);
  if (!componentClass) {
    return console.error(`Svelte component "${key}" not among registered keys:`, [...listComponents()]);
  }
  const { __html : html, ...props } = JSON.parse(target.querySelector(':scope > script[type="application/json"]:first-child')?.textContent || "{}");
  const component = html ?
    new InjectHtml({ target, props: { ...props, component: componentClass, html } }) :
    new componentClass({ target, props });
  // Save a reference to the mounted component on its containing DOM element in
  // case another script needs it later. For the API exposed by the mounted
  // component, see https://svelte.dev/docs#run-time-client-side-component-api.
  // In case of InjectHtml, $set should still work but any custom api exposed by
  // the wrapped component wouldn't be available.
  target.svelteComponent = component;
  return () => component.$destroy(); // Trigger Svelte's unmount behavior if something else removes the container
})

export default register;
